import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { auth } from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import {
  AngularFirestore,
  AngularFirestoreDocument
} from '@angular/fire/firestore';

import { Observable, combineLatest, of } from 'rxjs';
import { switchMap, first, map } from 'rxjs/operators';
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: 'root'
})
export class CallService {

  constructor(
    private afs: AngularFirestore,
  ) { }

  getReservationByUid(uid) {
    const reservationRef: AngularFirestoreDocument<any> = this.afs.doc(`reservations/${uid}`);

    return reservationRef.get()
    .pipe(
      map(doc => {
        if (doc.exists) {
          return doc.data();
        } else {
          return;
        }
      })
    );
  }
}
